
import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
  Switch,
} from "@mui/material";

const Promotions = ({ contentData, setContentData, showIcons, setShowIcons }: any) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Initialize with existing data or defaults
  const [promotion, setPromotion] = useState({
    isActive: contentData.promotion?.isActive || false,
    discountPercent: contentData.promotion?.discountPercent || 0,
    isFree: contentData.promotion?.isFree || false,
    code: contentData.promotion?.code || "",
  });

  // Function to check if all required fields are filled
  const checkAllFieldsFilled = () => {
    const isFormComplete =
      promotion.isActive &&
      (promotion.discountPercent > 0 || promotion.isFree) &&
      promotion.code.trim().length > 0;

    // Update showIcons for `promotions`
    // setShowIcons((prevState: any) => ({
    //   ...prevState,
    //   promotions: isFormComplete,
    // }));
  };

  // Handle toggling of the promotional switch
  const handleTogglePromo = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setPromotion((prev) => ({
      ...prev,
      isActive: isChecked,
    }));
    // Update parent contentData
    setContentData((prevContentData: any) => ({
      ...prevContentData,
      promotion: {
        ...prevContentData.promotion,
        isActive: isChecked,
      },
    }));
  };

  // Handle changes in discount, free option, and code
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked, type } = e.target;
    let newValue = type === "checkbox" ? checked : value;

    // Ensure discountPercent is between 1 and 100
    if (name === "discountPercent") {
      const numericValue = Number(newValue);
      if (numericValue < 0 || numericValue > 100) {
        return; // Prevent updating state with invalid values
      }
    }

    setPromotion((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    // Update parent contentData
    setContentData((prevContentData: any) => ({
      ...prevContentData,
      promotion: {
        ...prevContentData.promotion,
        [name]: newValue,
      },
    }));

  };

  // Call checkAllFieldsFilled after each render or field change
  useEffect(() => {
    checkAllFieldsFilled();
  }, [promotion]);

  return (
    <Grid
      container
      spacing={3}
      p={{ xs: 2, md: 5 }}
      mt={{ xs: 3, md: 0 }}
      flexDirection="column"
    >
      <Box>
        <FormControlLabel
          label="Promotional Coupon"
          labelPlacement="start"
          sx={{
            "& .MuiFormControlLabel-label": {
              fontSize: "18px",
              fontWeight: 700,
              color: "#797979",
              marginRight: "16px",
            },
          }}
          control={
            <Switch
              checked={promotion.isActive}
              onChange={handleTogglePromo}
              color="primary"
              sx={{
                "& .MuiSwitch-switchBase": {
                  padding: "3px",
                  "&.Mui-checked": {
                    transform: "translateX(28px)",
                    color: "#fff",
                    "& + .MuiSwitch-track": {
                      backgroundColor: "#34C759",
                    },
                  },
                },
                "& .MuiSwitch-thumb": {
                  width: 28,
                  height: 28,
                  boxShadow: "none",
                },
                "& .MuiSwitch-track": {
                  borderRadius: 13,
                  backgroundColor: "#E9E9EA",
                },
                width: 62,
                height: 34,
                padding: 0,
              }}
            />
          }
        />
      </Box>

      {promotion.isActive && (
        <>
          <Grid
            item
            xs={12}
            sm={6}
            display="flex"
            gap={1}
            flexDirection="column"
          >
            <label htmlFor="discount" style={styleSheet.labelText}>
              Discount
            </label>
            <Grid display="flex" gap={2} alignItems="center">
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                }}
              >
                <TextField
                  name="discountPercent"
                  type="number"
                  value={promotion.discountPercent}
                  onChange={handleChange}
                  inputProps={{ min: 1, max: 100 }} // Restricts input field to 1-100
                  InputProps={{
                    endAdornment: <Box sx={{ ml: 1 }}>% </Box>,
                    sx: { borderRadius: "8px" },
                  }}
                  fullWidth
                />
                {/* <FormControlLabel
                  control={
                    <Checkbox
                      name="isFree"
                      checked={promotion.isFree}
                      onChange={handleChange}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: "35px",
                          color: "#BFBFBF",
                        },
                      }}
                    />
                  }
                  label="Free"
                /> */}
              </Box>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            display="flex"
            gap={1}
            flexDirection="column"
          >
            <label htmlFor="code" style={styleSheet.labelText}>
              Code
            </label>
            <Grid display="flex" gap={2} alignItems="center">
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                }}
              >
                <TextField
                  name="code"
                  value={promotion.code}
                  onChange={handleChange}
                  variant="outlined"
                  fullWidth
                />
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default Promotions;

const styleSheet = {
  labelText: {
    fontWeight: 400,
    fontSize: "17px",
    color: "#000000",
  },
};
